import { getSettings } from './settingsService';

// Function to apply settings as CSS variables to the document
export const applySettingsToCSS = async () => {
  try {
    const settings = await getSettings();
    
    // Create CSS variables from settings
    const cssVariables = `
      :root {
        /* Branding */
        --site-name: '${settings.site_name || 'MeddyList'}';
        
        /* Colors */
        --primary-color: ${settings.primary_color || '#007bff'};
        --secondary-color: ${settings.secondary_color || '#6c757d'};
        --accent-color: ${settings.accent_color || '#28a745'};
        --background-color: ${settings.background_color || '#ffffff'};
        --text-color: ${settings.text_color || '#333333'};
        
        /* Header & Footer */
        --header-background: ${settings.header_background || '#ffffff'};
        --footer-background: ${settings.footer_background || '#f8f9fa'};
        --header-text-color: ${settings.header_text_color || '#333333'};
        --footer-text-color: ${settings.footer_text_color || '#666666'};
        
        /* Buttons */
        --button-primary-color: ${settings.button_primary_color || '#007bff'};
        --button-secondary-color: ${settings.button_secondary_color || '#6c757d'};
        --button-text-color: ${settings.button_text_color || '#ffffff'};
        
        /* Forms */
        --form-background: ${settings.form_background || '#ffffff'};
        --form-border-color: ${settings.form_border_color || '#ced4da'};
        --form-focus-color: ${settings.form_focus_color || '#007bff'};
        
        /* Logo URLs */
        --logo-url: url('${settings.logo_url || ''}');
        --favicon-url: url('${settings.favicon_url || ''}');
      }
    `;

    // Remove existing settings style if it exists
    const existingStyle = document.getElementById('dynamic-settings-css');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Create new style element
    const styleElement = document.createElement('style');
    styleElement.id = 'dynamic-settings-css';
    styleElement.textContent = cssVariables;

    // Add to document head
    document.head.appendChild(styleElement);

    // Apply custom CSS if provided
    if (settings.custom_css) {
      const customStyleElement = document.createElement('style');
      customStyleElement.id = 'custom-css';
      customStyleElement.textContent = settings.custom_css;
      document.head.appendChild(customStyleElement);
    }

    // Apply custom JavaScript if provided
    if (settings.custom_js) {
      try {
        // Remove existing custom JS if it exists
        const existingScript = document.getElementById('custom-js');
        if (existingScript) {
          existingScript.remove();
        }

        const scriptElement = document.createElement('script');
        scriptElement.id = 'custom-js';
        scriptElement.textContent = settings.custom_js;
        document.head.appendChild(scriptElement);
      } catch (error) {
        console.error('Error applying custom JavaScript:', error);
      }
    }

    // Update favicon if provided
    if (settings.favicon_url) {
      const favicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
      if (favicon) {
        favicon.href = settings.favicon_url;
      } else {
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = settings.favicon_url;
        document.head.appendChild(newFavicon);
      }
    }

    // // Update page title if provided
    // if (settings.site_name) {
    //   document.title = settings.site_name;
    // }

    // // Apply meta tags for SEO
    // if (settings.meta_title) {
    //   let metaTitle = document.querySelector('meta[name="title"]');
    //   if (!metaTitle) {
    //     metaTitle = document.createElement('meta');
    //     metaTitle.name = 'title';
    //     document.head.appendChild(metaTitle);
    //   }
    //   metaTitle.content = settings.meta_title;
    // }

    // if (settings.meta_description) {
    //   let metaDescription = document.querySelector('meta[name="description"]');
    //   if (!metaDescription) {
    //     metaDescription = document.createElement('meta');
    //     metaDescription.name = 'description';
    //     document.head.appendChild(metaDescription);
    //   }
    //   metaDescription.content = settings.meta_description;
    // }

    // if (settings.meta_keywords) {
    //   let metaKeywords = document.querySelector('meta[name="keywords"]');
    //   if (!metaKeywords) {
    //     metaKeywords = document.createElement('meta');
    //     metaKeywords.name = 'keywords';
    //     document.head.appendChild(metaKeywords);
    //   }
    //   metaKeywords.content = settings.meta_keywords;
    // }

    // // Apply Google Analytics if provided (Static from DB)
    // if (settings.google_analytics_id) {
    //   // Remove existing GA script if it exists
    //   const existingGA = document.getElementById('google-analytics');
    //   if (existingGA) {
    //     existingGA.remove();
    //   }

    //   const gaScript = document.createElement('script');
    //   gaScript.id = 'google-analytics';
    //   gaScript.async = true;
    //   gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
    //   document.head.appendChild(gaScript);

    //   const gaConfig = document.createElement('script');
    //   gaConfig.textContent = `
    //     window.dataLayer = window.dataLayer || [];
    //     function gtag(){dataLayer.push(arguments);}
    //     gtag('js', new Date());
    //     gtag('config', '${settings.google_analytics_id}');
    //   `;
    //   document.head.appendChild(gaConfig);
    // }

    // // Apply Facebook Pixel if provided (Static from DB)
    // if (settings.facebook_pixel_id) {
    //   // Remove existing FB Pixel script if it exists
    //   const existingFB = document.getElementById('facebook-pixel');
    //   if (existingFB) {
    //     existingFB.remove();
    //   }

    //   const fbScript = document.createElement('script');
    //   fbScript.id = 'facebook-pixel';
    //   fbScript.textContent = `
    //     !function(f,b,e,v,n,t,s)
    //     {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    //     n.queue=[];t=b.createElement(e);t.async=!0;
    //     t.src=v;s=b.getElementsByTagName(e)[0];
    //     s.parentNode.insertBefore(t,s)}(window, document,'script',
    //     'https://connect.facebook.net/en_US/fbevents.js');
    //     fbq('init', '${settings.facebook_pixel_id}');
    //     fbq('track', 'PageView');
    //   `;
    //   document.head.appendChild(fbScript);
    // }

    return true;
  } catch (error) {
    console.error('Error applying settings to CSS:', error);
    return false;
  }
};

// Function to apply settings immediately (for use in components)
export const applySettingsImmediately = (settings) => {
  try {
    const cssVariables = `
      :root {
        --primary-color: ${settings.primary_color || '#007bff'};
        --secondary-color: ${settings.secondary_color || '#6c757d'};
        --accent-color: ${settings.accent_color || '#28a745'};
        --background-color: ${settings.background_color || '#ffffff'};
        --text-color: ${settings.text_color || '#333333'};
        --header-background: ${settings.header_background || '#ffffff'};
        --footer-background: ${settings.footer_background || '#f8f9fa'};
        --header-text-color: ${settings.header_text_color || '#333333'};
        --footer-text-color: ${settings.footer_text_color || '#666666'};
        --button-primary-color: ${settings.button_primary_color || '#007bff'};
        --button-secondary-color: ${settings.button_secondary_color || '#6c757d'};
        --button-text-color: ${settings.button_text_color || '#ffffff'};
        --form-background: ${settings.form_background || '#ffffff'};
        --form-border-color: ${settings.form_border_color || '#ced4da'};
        --form-focus-color: ${settings.form_focus_color || '#007bff'};
      }
    `;

    // Remove existing settings style if it exists
    const existingStyle = document.getElementById('dynamic-settings-css');
    if (existingStyle) {
      existingStyle.remove();
    }

    // Create new style element
    const styleElement = document.createElement('style');
    styleElement.id = 'dynamic-settings-css';
    styleElement.textContent = cssVariables;

    // Add to document head
    document.head.appendChild(styleElement);

    // Apply Google Analytics immediately if provided
    if (settings.google_analytics_id) {
      // Remove existing GA script if it exists
      const existingGA = document.getElementById('google-analytics');
      if (existingGA) {
        existingGA.remove();
      }

      const gaScript = document.createElement('script');
      gaScript.id = 'google-analytics';
      gaScript.async = true;
      gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
      document.head.appendChild(gaScript);

      const gaConfig = document.createElement('script');
      gaConfig.textContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${settings.google_analytics_id}');
      `;
      document.head.appendChild(gaConfig);
    }

    // Apply Facebook Pixel immediately if provided
    if (settings.facebook_pixel_id) {
      // Remove existing FB Pixel script if it exists
      const existingFB = document.getElementById('facebook-pixel');
      if (existingFB) {
        existingFB.remove();
      }

      const fbScript = document.createElement('script');
      fbScript.id = 'facebook-pixel';
      fbScript.textContent = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${settings.facebook_pixel_id}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(fbScript);
    }

    return true;
  } catch (error) {
    console.error('Error applying settings immediately:', error);
    return false;
  }
};

// Function to get current settings as CSS variables
export const getSettingsAsCSSVariables = (settings) => {
  return {
    '--primary-color': settings.primary_color || '#007bff',
    '--secondary-color': settings.secondary_color || '#6c757d',
    '--accent-color': settings.accent_color || '#28a745',
    '--background-color': settings.background_color || '#ffffff',
    '--text-color': settings.text_color || '#333333',
    '--header-background': settings.header_background || '#ffffff',
    '--footer-background': settings.footer_background || '#f8f9fa',
    '--header-text-color': settings.header_text_color || '#333333',
    '--footer-text-color': settings.footer_text_color || '#666666',
    '--button-primary-color': settings.button_primary_color || '#007bff',
    '--button-secondary-color': settings.button_secondary_color || '#6c757d',
    '--button-text-color': settings.button_text_color || '#ffffff',
    '--form-background': settings.form_background || '#ffffff',
    '--form-border-color': settings.form_border_color || '#ced4da',
    '--form-focus-color': settings.form_focus_color || '#007bff',
  };
};

// Function to initialize settings on app startup
export const initializeSettings = async () => {
  try {
    await applySettingsToCSS();
    console.log('Settings initialized successfully');
  } catch (error) {
    console.error('Error initializing settings:', error);
  }
};
